// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-content {
  font-family: inherit;
  line-height: 1.6;
  padding-right: 12px;
  max-width: 100%;
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  overflow-x: hidden;
}
.chat-content__html {
  display: block !important;
  color: var(--primary-color-dark-500);
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
}
.chat-content__html:last-child {
  margin-bottom: 0;
}
.chat-content__loading {
  margin: 1.5rem 0;
}`, "",{"version":3,"sources":["webpack://./src/layouts/user/Research/components/ChatContentView/ChatContentView.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;AACF;AACE;EACE,yBAAA;EACA,oCAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AACJ;AACI;EACE,gBAAA;AACN;AAGE;EACE,gBAAA;AADJ","sourcesContent":[".chat-content {\n  font-family: inherit;\n  line-height: 1.6;\n  padding-right: 12px;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  word-break: break-word;\n  overflow-x: hidden;\n\n  &__html {\n    display: block !important;\n    color: var(--primary-color-dark-500);\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    word-break: break-word;\n    max-width: 100%;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  &__loading {\n    margin: 1.5rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
